import { publicClient, privateClient } from './client';
import { StoreView } from './StoreView';

const customStoreView = (pub: boolean) => new StoreView(pub ? publicClient : privateClient);
export default customStoreView;
